import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/antd.css';

import Sticky from 'vue3-sticky-directive'
import Vue3VideoPlay from 'vue3-video-play'; 
import 'vue3-video-play/dist/style.css'

import { Popconfirm ,Empty,Alert,Row, Col, Select, Drawer, Pagination, Tooltip, Tag, AutoComplete, Checkbox, Form, Dropdown, Modal, Button, Layout, Menu, ConfigProvider, DatePicker, Input, Steps, Spin, Table,Upload } from 'ant-design-vue';
import './assets/icons';
import SvgIcon from '@/components/SvgIcon'

router.beforeEach(async (to, from, next) => {
  //VuelocalStorage.setItem('pctoken',"eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ0b2tlbiIsImxvZ2luVHlwZSI6MiwibG9naW5OYW1lIjoiMTU4MTQ1MjE2NzEzIiwiaXNNaW5pVXNlciI6dHJ1ZSwiaWQiOjE3NzksImV4cCI6MTY5ODIzNDMwMCwiaWF0IjoxNjk4MTk4MzAwfQ.C_EvrQkeykUR_Wb-j7AH0BWOIwLiU-V0E7RkAvKr9rc")
  //VuelocalStorage.setItem('company',{companyId:20404})
  var pctoken = null

  if (localStorage.getItem('pctoken') != null && localStorage.getItem('pctoken') != undefined) {
    if (to.path == '/') {
      next({
        replace: true,
        name: 'homePage',
      })
    }
    else {
      next()
    }
  }
  else {
    if (to.path == '/') {
      next()
    }
    else {
      next({
        replace: true,
        name: 'loginPage',
      })
    }
  }


})
createApp(App).use(Empty).use(Upload).use(Alert).use(Pagination).use(Popconfirm ).use(Tooltip).use(Drawer).use(Dropdown).use(Tag).use(Checkbox).use(Row).use(Col).use(Sticky).use(AutoComplete).use(Select).use(Form).use(Modal).use(Table).use(store).use(Button).use(Spin).use(Input).use(Steps).use(Layout).use(Menu).use(router).use(ConfigProvider).use(DatePicker).use(Vue3VideoPlay).component('svg-icon', SvgIcon).mount('#app')
